import { useTranslation } from 'react-i18next';
import './PendingQueue.css';

export interface PendingQuestion {
  id: string;
  text: string;
  createdAt: number;
}

interface PendingQueueProps {
  items: PendingQuestion[];
  onCancel: (id: string) => void;
  onSendNow: (id: string) => void;
}

export default function PendingQueue({ items, onCancel, onSendNow }: PendingQueueProps) {
  const { t } = useTranslation('chat');
  if (items.length === 0) return null;

  return (
    <div className="pending-queue" role="list" aria-label={t('queue.label')}>
      {items.map(q => (
        <div key={q.id} className="pending-queue__item" role="listitem">
          <span className="pending-queue__text" title={q.text}>{q.text}</span>
          <div className="pending-queue__actions">
            <button
              type="button"
              className="pending-queue__btn"
              onClick={() => onCancel(q.id)}
              title={t('queue.remove')}
              aria-label={t('queue.removeNamed', { text: q.text })}
            >
              <img src="/icons/icon-chat-close.svg" alt="" width={16} height={16} />
            </button>
            <button
              type="button"
              className="pending-queue__btn"
              onClick={() => onSendNow(q.id)}
              title={t('queue.sendNow')}
              aria-label={t('queue.sendNowNamed', { text: q.text })}
            >
              <img src="/icons/icon-chat-send.svg" alt="" width={16} height={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
